import { Sidebar, useSidebar } from "@volca/ui/components/ui/sidebar";
import { SidebarIconRail } from "./sidebar-icon-rail";
import { SidebarMobileNav } from "./sidebar-mobile-nav";
import { SidebarNavUser } from "./sidebar-nav-user";
import type { SettingsNav } from "./use-settings-nav";
import { WorkspaceMenu } from "./workspace-menu";

interface AppSidebarProps {
  settings: SettingsNav | null;
  onImpersonate?: () => void;
}

export const AppSidebar = ({ settings, onImpersonate }: AppSidebarProps) => {
  const { isMobile } = useSidebar();
  if (!isMobile) {
    return (
      <SidebarIconRail
        account={
          <WorkspaceMenu presentation="rail" onImpersonate={onImpersonate} />
        }
      />
    );
  }

  return (
    <Sidebar className="bottom-(--app-devbar-height) h-auto in-data-[impersonating]:top-1 in-data-[impersonating]:left-1">
      <SidebarMobileNav
        account={
          <SidebarNavUser settings={settings} onImpersonate={onImpersonate} />
        }
      />
    </Sidebar>
  );
};
